import { computed } from 'vue'
import { useSiteInfoStore } from 'stores/site-info/index.js'

const COMPRESSED_IMAGE_FORMATS = ['webp', 'svg', 'png', 'jpg']
const COMPRESSED_IMAGE_SIZES = ['xs', 'sm', 'md', 'lg', 'xl']

function getCdnDomainBack() {
  const raw = process.env.CDN_DOMAIN_BACK || ''
  return raw || ''
}

export function getCompressedImages(compressedImage) {
  if (!compressedImage) {
    return null
  }
  const format = COMPRESSED_IMAGE_FORMATS.find((name) => {
    return COMPRESSED_IMAGE_SIZES.some((size) => compressedImage[name]?.[size])
  })
  return format ? compressedImage[format] : null
}

export function useImages() {
  const siteInfoStore = useSiteInfoStore()
  const region = computed(() => siteInfoStore.getRealRegion)

  const cdnDomain = computed(() => (region.value === 'RU' ? '' : getCdnDomainBack()))

  function cleanPath(path) {
    return path.replace(/^\/+/, '')
  }

  function generateImageUrl(filePath) {
    const path = cleanPath(filePath)
    const prefix = cdnDomain.value || process.env.BASE_URL || ''
    return `${prefix}${prefix.endsWith('/') ? '' : '/'}${path}`.replace(/([^:]\/)\/+/g, '$1')
  }

  function getUrlWithModifier(url, modifier) {
    if (!url) {
      return ''
    }
    if (!modifier) {
      return generateImageUrl(url)
    }

    const segments = cleanPath(url).split('/')
    const filename = segments.pop()
    segments.push(`${modifier}/${filename}`)
    return generateImageUrl(segments.join('/'))
  }

  function getCompleteSrcset(url) {
    return `${generateImageUrl(url)} 1x, ${getUrlWithModifier(url, 2)} 2x, ${getUrlWithModifier(url, 3)} 3x`
  }

  return {
    cdnDomain,
    generateImageUrl,
    getUrlWithModifier,
    getCompleteSrcset,
  }
}
